import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export interface DiscountEditDialogData {
  mode: 'line' | 'global';
  amountDecimalPlaces: number;
  coinSymbol: string;
  initialValue: number | null;
  initialType: 'AMOUNT' | 'PERCENTAGE';
  maxAmount: number;
  hasGlobalDiscount?: boolean; 
  globalDiscountValue?: number | null; 
}

@Component({
  selector: 'app-apply-discount-dialog',
  templateUrl: './apply-discount-dialog.component.html',
  styleUrls: ['./apply-discount-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ApplyDiscountDialogComponent {
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ApplyDiscountDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DiscountEditDialogData
  ) {
    this.form = this.fb.group({
      type: [null],
      value: [{ value: null, disabled: true }]
    });

    if (data.initialType && data.initialValue !== null && data.initialValue !== undefined) {
      this.form.get('type')?.setValue(data.initialType);
      this.form.get('value')?.enable({ emitEvent: false });
      this.form.get('value')?.setValue(data.initialValue);
      this.applyValueValidators();
    }
  }

  private applyValueValidators() {
    const discountValueControl = this.form.get('value');
    const type = this.form.get('type')?.value as 'AMOUNT' | 'PERCENTAGE' | null;
    if (!discountValueControl) return;

    const validators = [Validators.required, Validators.min(0)];
    if (type === 'PERCENTAGE') {
      validators.push(Validators.max(100));
    } else if (type === 'AMOUNT' && typeof this.data.maxAmount === 'number') {
      validators.push(Validators.max(this.data.maxAmount));
    }

    discountValueControl.setValidators(validators);
    discountValueControl.updateValueAndValidity({ emitEvent: false });
  }

  onTypeSelect(type: 'AMOUNT' | 'PERCENTAGE') {
    this.form.get('type')?.setValue(type);
    this.form.get('value')?.enable();
    if (this.form.get('value')?.value == null) {
      this.form.get('value')?.setValue(0, { emitEvent: false });
    }
    this.applyValueValidators();
    this.form.get('value')?.markAsTouched();
  }

  save() {
    if (this.form.invalid) {
      this.form.get('value')?.markAsTouched();
      return;
    }
    const value = this.form.get('value')?.value;
    const type = this.form.get('type')?.value;
    this.dialogRef.close({ value, type });
  }

  cancel() {
    this.dialogRef.close(null);
  }

}
